import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const ServicePageApi = createApi({
  reducerPath: "ServicePageApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["SERVICEPAGEAPI"],
  endpoints: (build) => ({
    getServicePages: build.query({
      query: ({ page, limit, status, search, fromDate, toDate, category }) => {
        let queryParams = "";
        if (page) queryParams += `page=${page}&`;
        if (limit) queryParams += `limit=${limit}&`;
        if (status) queryParams += `status=${status}&`;
        if (search) queryParams += `search=${encodeURIComponent(search)}&`;
        if (category) queryParams += `category=${encodeURIComponent(category)}&`;
        if (fromDate) queryParams += `fromDate=${fromDate}&`;
        if (toDate) queryParams += `toDate=${toDate}&`;

        return {
          url: `/services?${queryParams}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["SERVICEPAGEAPI"],
    }),

    getPublicServicePages: build.query({
      query: ({ status, page, limit, search, category }) => {
        let queryParams = "";
        if (page) queryParams += `page=${page}&`;
        if (limit) queryParams += `limit=${limit}&`;
        if (status) queryParams += `status=${status}&`;
        if (search) queryParams += `search=${encodeURIComponent(search)}&`;
        if (category) queryParams += `category=${encodeURIComponent(category)}&`;

        return {
          url: `/services/view-all?${queryParams}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["SERVICEPAGEAPI"],
    }),

    getServicePageBySlug: build.query({
      query: ({ slug }) => ({
        url: `/services/website/service-page/${slug}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SERVICEPAGEAPI"],
    }),

    addServicePage: build.mutation({
      query: ({ data }) => ({
        url: `/services`,
        method: "POST",
        body: data,
        // FormData used for image uploads, no Content-Type header needed
      }),
      invalidatesTags: ["SERVICEPAGEAPI"],
    }),

    editServicePage: build.mutation({
      query: ({ id, data }) => ({
        url: `/services/${id}`,
        method: "PUT",
        body: data,
        // FormData used for image uploads
      }),
      invalidatesTags: ["SERVICEPAGEAPI"],
    }),

    deleteServicePage: build.mutation({
      query: ({ id }) => ({
        url: `/services/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SERVICEPAGEAPI"],
    }),
  }),
});

export const {
  useGetServicePagesQuery,
  useGetPublicServicePagesQuery,
  useGetServicePageBySlugQuery,
  useAddServicePageMutation,
  useEditServicePageMutation,
  useDeleteServicePageMutation,
} = ServicePageApi;
